<script lang="ts">
    import quill from "quill"
    import "quill/dist/quill.core.css"
    import "quill/dist/quill.snow.css"
    import ImageCompress from "quill-image-compress"
    import { _ } from "svelte-i18n"

    quill.register("modules/imageCompress", ImageCompress)

    export let value: string
    export let disabled = false
    export let placeholder = ""

    let editor: HTMLElement
    let richtextInput: HTMLElement
    let quillInstance: quill
    let initialized = false

    const tooltips = {
        bold: $_("components.richtext.bold"),
        italic: $_("components.richtext.italic"),
        underline: $_("components.richtext.underline"),
        strike: $_("components.richtext.strike"),
        align: $_("components.richtext.align"),
        blockquote: $_("components.richtext.blockquote"),
        "code-block": $_("components.richtext.code_block"),
        list: $_("components.richtext.list"),
        color: $_("components.richtext.color"),
        background: $_("components.richtext.background"),
        image: $_("components.richtext.image"),
        link: $_("components.richtext.link"),
        clean: $_("components.richtext.clean"),
    }

    function initEditor() {
        editor.innerHTML = value || ""
        quillInstance = new quill(editor, {
            modules: {
                history: {
                    delay: 2000,
                    maxStack: 500,
                    userOnly: true,
                },
                toolbar: [
                    [{ header: [false, 1, 2, 3, 4, 5, 6] }],
                    ["bold", "italic", "underline", "strike"],
                    [{ align: [] }, "blockquote", "code-block"],
                    [{ list: "ordered" }, { list: "bullet" }],
                    [{ color: [] }, { background: [] }],
                    ["image"],
                    ["link"],
                    ["clean"],
                ],
                imageCompress: {
                    quality: 0.6,
                    maxWidth: 1200,
                    maxHeight: 1200,
                    imageType: "image/jpeg", // default
                    debug: false,
                    suppressErrorLogging: false, // default
                    insertIntoEditor: undefined, // default
                },
            },
            placeholder,
            theme: "snow", // or 'bubble'
        })
        quillInstance.on("text-change", () => {
            // @ts-ignore
            if (editor.firstChild && editor.firstChild.innerHTML != value) {
                // @ts-ignore
                value = editor.firstChild.innerHTML
            }
        })

        initialized = true
    }

    $: if (!initialized && editor) {
        initEditor()
    }

    $: if (initialized) {
        // @ts-ignore
        if (editor.firstChild && editor.firstChild.innerHTML != value) {
            // @ts-ignore
            editor.firstChild.innerHTML = value
        }
        //        const delta = quillInstance.clipboard.convert(value)
        //quillInstance.setContents(delta, "silent")
    }

    $: if (initialized) {
        quillInstance.enable(!disabled)

        // add tooltips
        for (const [key, value] of Object.entries(tooltips)) {
            const buttons = richtextInput.querySelectorAll(`.ql-${key}`)
            buttons?.forEach((button) => {
                button.setAttribute("title", value)
            })
        }
    }
</script>

<div class="richtext-input" bind:this="{richtextInput}">
    <div class="editor" bind:this="{editor}" style="background-color: white"></div>
</div>
